import invariant from 'invariant';

import type { I18nFn } from 'i18n/types/I18nFn';
import { COUNTRIES } from 'utils/constants/general/countries';
import { LOCALES } from 'utils/constants/general/locales';
import { US_STATES } from 'utils/constants/general/usStates';

export function getLocaleName(localeId: UserLocale) {
  const localeName = LOCALES[localeId];
  invariant(localeName, `Invalid locale ID: ${localeId}`);
  return localeName;
}

export function getCountryName(i18n: I18nFn, countryId: string) {
  const country = COUNTRIES(i18n).find(({ id }) => id === countryId);
  if (country) return country.name;
  return '';
}

export function getUsStateName(i18n: I18nFn, stateId: string) {
  const state = US_STATES(i18n).find(({ id }) => id === stateId);
  if (state) return state.name;
  return '';
}
